<template>
  <div>
    <b-alert v-for="error in errors" :key="error.message" v-model="popAlert" variant="danger" dismissible
      class="mx-md-3 mt-3">
      {{ error.message }}
    </b-alert>
    <div class="row mx-1 mt-2">
      <div class="col">
        <b-card bg-variant="light" v-if="this.$store.state.userInfo && this.$store.state.usersAccessibleUnits.length > 1">
          <b-form-group :label="$t(`common.unit`) + ':'" label-class="font-weight-bold text-align-start" label-cols="2"
            class="col-xs-12 col-md-9 col-xl-6 float-left my-auto">
            <unit-selector @input-change="unitChanged" />
          </b-form-group>
        </b-card>
      </div>
    </div>
    <div class="row mx-1" :class="selectedUnitId ? '' : 'mb-2'">
      <div class="col-xl-4 col-6 mt-3" v-if="showComp.licenses">
        <pending-licenses-comp v-on:error:api.capture="handleError" :unitId="selectedUnitId"
          @show-comp="visibleComponentChanged" />
      </div>
      <div class="col-xl-4 col-6 mt-3" v-if="showComp.excursions">
        <pending-excursions-comp v-on:error:api.capture="handleError" :unitId="selectedUnitId"
          @show-comp="visibleComponentChanged" />
      </div>
      <div class="col-xl-4 col-6 mt-3" v-if="showComp.trainings">
        <upcoming-trainings-comp v-on:error:api.capture="handleError" @show-comp="visibleComponentChanged" />
      </div>
      <div class="col-xl-4 col-6 mt-3" v-if="showComp.activitiesTrainee">
        <pending-apply-activities-trainee-comp @show-comp="visibleComponentChanged" />
      </div>
      <div class="col-xl-4 col-6 mt-3" v-if="this.isTrainer">
        <pending-trainings-comp />
      </div>
      <div class="col-xl-4 col-6 mt-3" v-if="this.isTrainer">
        <pending-apply-activities-comp />
      </div>
    </div>

    <div class="row mx-1 mt-2" v-if="selectedUnitId">
      <filters-comp v-if="showComp.achievements" @branch-changed='branchChanged' :unitId="selectedUnitId" />
    </div>
    <div class="row mx-1 mb-2" v-if="selectedUnitId">
      <div class="col-4">
        <achievements-comp v-if="showComp.achievements" @show-comp="visibleComponentChanged" :branch="branch"
          :unitId="selectedUnitId" />
      </div>
      <div class="col-4">
        <excursions-participation-comp v-if="showComp.excursions" :branch="branch" :unitId="selectedUnitId" />
      </div>
      <div class="col-4">
        <eval-criteria-comp v-if="branch == 'CUB' && showComp.achievements" :branch="branch" :unitId="selectedUnitId" />
      </div>
    </div>
  </div>
</template>

<script>
import AchievementsComp from "./achievementsComp.vue"
import ExcursionsParticipationComp from "./excursionParticipationComp.vue";
import EvalCriteriaComp from "./evalCriteriaComp.vue"
import PendingLicensesComp from "./pendingLicensesComp.vue";
import PendingExcursionsComp from "./pendingExcursionsComp.vue";
import UpcomingTrainingsComp from "./upcomingTrainingsComp.vue";
import FiltersComp from "./filtersComp.vue";
import UnitSelector from "../common/unitSelector.vue";
import PendingTrainingsComp from "./pendingTrainingsComp.vue";
import PendingApplyActivitiesComp from "./pendingApplyActivitiesComp.vue";
import PendingApplyActivitiesTraineeComp from "./pendingApplyActivitiesTraineeComp.vue";
import {getSelectedUnitId} from "@/services/utils";


const Dashboard = {
  name: 'Dashboard',
  components: {
    AchievementsComp,
    ExcursionsParticipationComp,
    EvalCriteriaComp,
    PendingLicensesComp,
    PendingExcursionsComp,
    UpcomingTrainingsComp,
    FiltersComp,
    UnitSelector,
    PendingTrainingsComp,
    PendingApplyActivitiesComp,
    PendingApplyActivitiesTraineeComp
  },
  data: function () {
    return {
      showComp: {
        licenses: true,
        achievements: true,
        excursions: true,
        trainings: true,
        activitiesTrainee: true
      },
      branch: 'CUB',
      selectedUnitId: null,
      popAlert: false,
      errors: null,
    }
  },
  computed: {
    username() {
      return this.$store.state.auth.username;
    },
    isTrainer() {
      let isTrainer = false;
      this.$store.state.userInfo.roles.forEach(role => {
        if (role.name == 'TRAINER') isTrainer = true;
      })
      return isTrainer
    },
  },
  mounted() {
    this.selectedUnitId = getSelectedUnitId(this.$store);
  },
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length > 0;
      if (errors?.length > 0) {
        window.scrollTo(0, 0);
      }
    },
    branchChanged(newBranch) {
      this.branch = newBranch;
    },
    unitChanged(unit) {
      this.selectedUnitId = unit ? unit.id : null;
      if (this.selectedUnitId) {
        this.$store.state.globalUnitId = String(this.selectedUnitId);
        localStorage.setItem('global-selected-unit-id', String(this.selectedUnitId));
      } else {
        this.$store.state.globalUnitId = null;
        localStorage.clear('global-selected-unit-id');
      }
    },
    visibleComponentChanged(visibility) {
      this.$set(this.showComp, visibility.name, visibility.value);
    },
  }
}
export default Dashboard
</script>

<style>
h3 {
  margin-bottom: 5%;
}
</style> 